import { useState } from "react"
import { ContactFormType } from "../../types/mainModulTypes"
import BaseHeadline from "../common/BaseHeadline"
import BaseRichtext from "../common/BaseRichtext"
import { API, CDS } from "../../constants/constants"
import axios from "axios"
import PrimaryButton from "../common/PrimaryButton"

export type FormData = {
    name: string
    company: string
    email: string
    phone: string
    subject: string
    message: string
}

export default function ContactForm(props: ContactFormType) {
    const [formData, setFormData] = useState<FormData>({
        name: "",
        company: "",
        email: "",
        phone: "",
        subject: "",
        message: "",
    })

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target
        setFormData((prev) => ({ ...prev, [name]: value }))
    }

    const [thankYouMsg, setThankYouMsg] = useState(false)
    const [errorMsg, setErrorMsg] = useState(false)
    const [errorText, setErrorText] = useState("Nicht alle Pflichtfelder ausgefüllt!")

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault()
        try {
            if (formData.name === "" || formData.email === "" || formData.message === "" || formData.subject === "") {
                setErrorMsg(true)
                return
            }

            const formDataToSend = new FormData()
            formDataToSend.append("name", formData.name)
            formDataToSend.append("company", formData.company)
            formDataToSend.append("email", formData.email)
            formDataToSend.append("phone", formData.phone)
            formDataToSend.append("subject", formData.subject)
            formDataToSend.append("message", formData.message)

            const fileInput = document.querySelector('input[type="file"]') as HTMLInputElement
            if (fileInput && fileInput.files) {
                for (let i = 0; i < fileInput.files.length; i++) {
                    formDataToSend.append("documents", fileInput.files[i])
                }
            }
            await axios
                .post(CDS.API, formDataToSend, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        "X-Auth": CDS.KEY,
                    },
                })
                .then((_) => {
                    setThankYouMsg(true)
                    setErrorMsg(false)
                })
                .catch((err) => {
                    setErrorMsg(true)
                    setThankYouMsg(false)

                    setErrorText(err.response.data.DisplayMessage ?? "Es gab einen Fehler. Die Kontaktanfrage konnte nicht gesendet werden.")
                })
        } catch (error) {
            console.error("Error sending message", error)
        }
    }

    return (
        <div className="max-w-content mx-auto bg-accent rounded-default lg:shadow-xl px-4 lg:px-12 py-8">
            <div className="flex flex-col items-center text-center">
                <BaseHeadline headlineType={3} label={props?.contactFormHeading} classProps="pb-8" />
                <BaseRichtext content={props?.contactFormText} />
                <img
                    src={API + props?.contactFormIcon?.url}
                    alt={props?.contactFormIcon?.description ?? props?.contactFormIcon?.name}
                    className="self-end w-20 object-contain pb-2 -mt-2"
                />
            </div>
            <form onSubmit={handleSubmit} className="flex flex-col gap-6">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 ">
                    <input
                        type="text"
                        name="name"
                        placeholder="Name*"
                        value={formData.name}
                        onChange={handleChange}
                        required
                        disabled={thankYouMsg}
                        className="rounded-full px-6 py-2 bg-base-200 shadow-inner text-lg focus-visible:outline-primary"
                    />
                    <input
                        type="text"
                        name="company"
                        placeholder="Firma"
                        value={formData.company}
                        onChange={handleChange}
                        disabled={thankYouMsg}
                        className="rounded-full px-6 py-2 bg-base-200 shadow-inner text-lg focus-visible:outline-primary"
                    />
                    <input
                        type="email"
                        name="email"
                        placeholder="E-Mail*"
                        value={formData.email}
                        onChange={handleChange}
                        required
                        disabled={thankYouMsg}
                        className="rounded-full px-6 py-2 bg-base-200 shadow-inner text-lg focus-visible:outline-primary"
                    />
                    <input
                        type="tel"
                        name="phone"
                        placeholder="Telefon"
                        value={formData.phone}
                        onChange={handleChange}
                        disabled={thankYouMsg}
                        className="rounded-full px-6 py-2 bg-base-200 shadow-inner text-lg focus-visible:outline-primary"
                    />
                </div>
                <input
                    type="text"
                    name="subject"
                    placeholder="Thema*"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                    disabled={thankYouMsg}
                    className="rounded-full px-6 py-2 bg-base-200 shadow-inner text-lg focus-visible:outline-primary"
                />
                <textarea
                    name="message"
                    placeholder="Message*"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    disabled={thankYouMsg}
                    className="rounded-default px-6 py-2 h-64 bg-base-200 shadow-inner text-lg focus-visible:outline-primary"
                />
                <input
                    type="file"
                    name="documents"
                    multiple
                    disabled={thankYouMsg}
                    className="cursor-pointer w-fit self-end rounded-full text-sm px-6 py-2 bg-base-200 shadow-inner focus-visible:outline-primary file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-primary file:text-accent hover:file:bg-primary/90"
                />
                <PrimaryButton text={"Abschicken"} active type="submit" classProps="w-full justify-center" disabled={thankYouMsg} fullWidth />
                {thankYouMsg && (
                    <p className="text-success text-sm font-semibold text-center px-4">Vielen Dank für deine Nachrich! Wir melden uns zeitnah!</p>
                )}
                {errorMsg && <p className="text-error text-sm font-semibold text-center px-4">{errorText}</p>}
            </form>
        </div>
    )
}
